import { ALTITUDE, PATH_ANGLE, ROUTE_SPACING } from '../../constants';
import useTranslation from '../../hooks/useTranslation';
import SliderFieldRow from '../SliderFieldRow';
import { metersToFeet } from 'utils/distanceUtil';

import { VerticalContainer } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const formatRangeLabel = (bound: number, unit: string) => `${bound} ${unit}`;

const PrimaryParamsSliders: FunctionComponent<Props> = ({
    className = '',
    config,
    onAltitudeChange,
    onPathAngleChange,
    onRouteSpacingChange,
    testId = TEST_ID
}) => {
    const { ALTITUDE_LABEL, PATH_ANGLE_LABEL, ROUTE_SPACING_LABEL } = useTranslation();
    const routeSpacingMinLabel = formatRangeLabel(ROUTE_SPACING.min, ROUTE_SPACING.unit);
    const routeSpacingMaxLabel = formatRangeLabel(ROUTE_SPACING.max, ROUTE_SPACING.unit);
    const pathAngleMinLabel = formatRangeLabel(PATH_ANGLE.min, PATH_ANGLE.unit);
    const pathAngleMaxLabel = formatRangeLabel(PATH_ANGLE.max, PATH_ANGLE.unit);
    const altitudeMinLabel = formatRangeLabel(ALTITUDE.min, ALTITUDE.unit);
    const altitudeMaxLabel = formatRangeLabel(ALTITUDE.max, ALTITUDE.unit);

    return (
        <VerticalContainer
            className={`${className} ${styles.primaryParamsSliders}`}
            testId={testId}>
            <SliderFieldRow
                label={ROUTE_SPACING_LABEL}
                max={ROUTE_SPACING.max}
                maxLabel={routeSpacingMaxLabel}
                min={ROUTE_SPACING.min}
                minLabel={routeSpacingMinLabel}
                onChange={onRouteSpacingChange}
                step={ROUTE_SPACING.step}
                unit={ROUTE_SPACING.unit}
                value={metersToFeet(config.routeSpacing)}
            />

            <SliderFieldRow
                label={PATH_ANGLE_LABEL}
                max={PATH_ANGLE.max}
                maxLabel={pathAngleMaxLabel}
                min={PATH_ANGLE.min}
                minLabel={pathAngleMinLabel}
                onChange={onPathAngleChange}
                step={PATH_ANGLE.step}
                unit={PATH_ANGLE.unit}
                value={config.pathAngleDegrees}
            />

            <SliderFieldRow
                label={ALTITUDE_LABEL}
                max={ALTITUDE.max}
                maxLabel={altitudeMaxLabel}
                min={ALTITUDE.min}
                minLabel={altitudeMinLabel}
                onChange={onAltitudeChange}
                step={ALTITUDE.step}
                unit={ALTITUDE.unit}
                value={metersToFeet(config.altitudeAgl)}
            />
        </VerticalContainer>
    );
};

export default PrimaryParamsSliders;
